import {Formik} from 'formik';
import {
    ActionBar,
    FormWithActionBar,
    NextSubmitButton,
    PacFormikComponentState
} from "@pac/platform-ui-components";

import {EmailFormValidationSchema} from "../../accounts/forms/EmailFormValidationSchema.ts";
import {EmailFormComponent} from "./EmailFormComponent.tsx";
import {HandoffEmail} from "../types.ts";

export const HandoffEmailForm = ({
                                     emailAddress,
                                     handleSubmit
                                 }: {
    emailAddress: string,
    handleSubmit: (values: HandoffEmail) => Promise<void>
}) => {

    const initialValues: HandoffEmail = {
        email: emailAddress,
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={EmailFormValidationSchema}
            onSubmit={handleSubmit}
        >
            {(props) => (
                <FormWithActionBar
                    handleSubmit={props.handleSubmit}
                    actionBar={<ActionBar primaryAction={<NextSubmitButton loading={props.isSubmitting}/>}/>}
                >
                    <EmailFormComponent {...props} />
                    <PacFormikComponentState enabled={false} {...props} />
                </FormWithActionBar>
            )}
        </Formik>
    );
};
